import { SvgIcon, SvgIconProps } from '@mui/material';
import './ccf-locations-icon.module.scss';

/* eslint-disable-next-line */
export interface CcfLocationsIconProps extends SvgIconProps {}

/**
 *
 * @param props - CcfLocationsIcon
 * @example <CcfLocationsIcon />
 * @returns
 */
export function CcfLocationsIcon(props: CcfLocationsIconProps) {
  return (
    <SvgIcon
      // width="14"
      // height="20"
      // viewBox="0 0 14 20"
      // fill="none"
      {...props}
    >
      <path
        d="M7.00016 2C7.65677 2 8.30695 2.12933 8.91357 2.3806C9.5202 2.63188 10.0714 3.00017 10.5357 3.46447C11 3.92876 11.3683 4.47995 11.6196 5.08658C11.8708 5.69321 12.0002 6.34339 12.0002 7C12.0133 7.83868 11.8064 8.66617 11.4002 9.4L7.00016 17.4L2.60016 9.4C2.19389 8.66617 1.98702 7.83868 2.00016 7C2.00016 5.67392 2.52694 4.40215 3.46462 3.46447C4.4023 2.52678 5.67407 2 7.00016 2ZM7.00016 0C5.14364 0 3.36316 0.737498 2.05041 2.05025C0.737653 3.36301 0.000155422 5.14348 0.000155422 7C-0.00797127 8.19326 0.302734 9.36703 0.900156 10.4L5.70016 19.2C5.83305 19.4311 6.02157 19.6253 6.24861 19.765C6.47564 19.9047 6.73398 19.9855 7.00016 20C7.26634 19.9855 7.52468 19.9047 7.75171 19.765C7.97874 19.6253 8.16726 19.4311 8.30016 19.2L13.1002 10.4C13.6976 9.36703 14.0083 8.19326 14.0002 7C14.0002 5.14348 13.2627 3.36301 11.9499 2.05025C10.6371 0.737498 8.85667 0 7.00016 0ZM7.00016 6C7.26537 6 7.51973 6.10536 7.70726 6.29289C7.8948 6.48043 8.00016 6.73478 8.00016 7C8.00016 7.26522 7.8948 7.51957 7.70726 7.70711C7.51973 7.89464 7.26537 8 7.00016 8C6.73494 8 6.48059 7.89464 6.29305 7.70711C6.10551 7.51957 6.00016 7.26522 6.00016 7C6.00016 6.73478 6.10551 6.48043 6.29305 6.29289C6.48059 6.10536 6.73494 6 7.00016 6ZM7.00016 4C6.20451 4 5.44144 4.31607 4.87884 4.87868C4.31623 5.44129 4.00016 6.20435 4.00016 7C4.00016 7.79565 4.31623 8.55871 4.87884 9.12132C5.44144 9.68393 6.20451 10 7.00016 10C7.79581 10 8.55887 9.68393 9.12148 9.12132C9.68409 8.55871 10.0002 7.79565 10.0002 7C10.0002 6.20435 9.68409 5.44129 9.12148 4.87868C8.55887 4.31607 7.79581 4 7.00016 4Z"
        fill="#FF9400"
      />
    </SvgIcon>
  );
}

export default CcfLocationsIcon;
